import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaURLSearchParamsNode } from './TypedNode'
import { SchemaURLSearchParamsModel } from './ViewModel'

export const SchemaURLSearchParamsPlugin = createSchemaPlugin(
  'Schema.URLSearchParams',
  SchemaURLSearchParamsModel,
  SchemaURLSearchParamsNode
)
